export * from './tab-config.model';
